import LinkForm from "./LinkForm"
const isLogged =  localStorage.getItem("tokenSmarthop") ? true : false;

const config = {
	settings: {
		layout: {
			config: {
				navbar: {
					display: isLogged,
				},
				toolbar: {
					display: isLogged,
				},
				footer: {
					display: false,
				},
				leftSidePanel: {
					display: isLogged,
				},
				rightSidePanel: {
					display: isLogged,
				},
			},
		},
	},
	routes: [
		{
			path: "/url",
			component: LinkForm,
		},
	],
};

export default config;
